import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import CompanyForm from '../Forms/CompanyForm';

const AddEditCompanyModal = ({
	dataCompany,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Empresa
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información General
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '2' })}
							onClick={() => {
								toggleTab('2');
							}}
						>
							Información de contacto
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '3' })}
							onClick={() => {
								toggleTab('3');
							}}
						>
							Información Comercial
						</NavLink>
					</NavItem>
				</Nav>
			</div>

			<CompanyForm
				dataCompany={dataCompany}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditCompanyModal;
